import React from "react";

function DrawButton(props) {
    const buttonStyle = {
        opacity: "0.8",
        backgroundColor: props.isActive ? "#dc3545" : "transparent", // Red background when active
        color: props.isActive ? "white" : "#dc3545", // White text/icon when active, red when not
        marginRight: "10px"
    };

    return (
        <button type="button" className="btn btn-outline-danger btn-sm photoEditorButton" style={buttonStyle} onClick={props.onClick} value={props.value}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-circle" viewBox="0 0 16 18">
                <path fill={props.isActive ? "white" : "#dc3545"} d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            </svg>
        </button>
    );
}

export default DrawButton;